import { gql } from "@apollo/client";

export const getTimeSheetQuery = gql`
query($input: TimeSheetFilterInput){
  getTimeSheet(input: $input) {
    message
    response
  }
}
`;